import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Select } from '../../../../CommonComponents/OPL/Select/Select/Select';
import { investmentObjectiveOptions } from './InvestmentObjective.meta';
import { MarginProps } from '../../../../theme/styledProps';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';

const fieldName = 'investmentObjective';

export const InvestmentObjective: React.FC<MarginProps> = props => {
  const formBag = useFormContext();

  return (
    <Box {...props}>
      <Controller
        control={formBag.control}
        name={fieldName}
        render={({ field }) => (
          <Select
            value={investmentObjectiveOptions.find(({ value }) => value === field.value)}
            label="What is your investment objective?"
            onChange={opt => {
              if (opt) {
                formBag.setValue(fieldName, opt.value);
              }
            }}
            options={investmentObjectiveOptions}
          />
        )}
      />
    </Box>
  );
};
